/**
*
*/
<template>
	<div>
		<!-- 面包屑导航 -->
		<router-view />
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
			<el-breadcrumb-item>{{Name}}</el-breadcrumb-item>
		</el-breadcrumb>

		<el-card style="margin-top: 20px;padding-top: 0px;padding-bottom: 0px;">
			<el-form :inline="true" :model="formInline" class="user-search">
				<el-form-item label="搜索：">
					<el-select v-model="formInline.BIllName" clearable filterable placeholder="请选择过滤条件 "
						style="display: block;height: 90%;" size="small">
						<el-option v-for="item in tableLabel" :key="item.item" :value-key="item.item" :label="item.label"
							:value="item.item">
							<span style="float: left; color: #8492a6; font-size: 17px">{{
				                  item.label
				                }}</span>
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-input size="small" v-model="formInline.deptName" placeholder="过滤值"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button size="small" type="primary" icon="el-icon-search" @click="search()">搜索</el-button>
					<el-button size="small" type="primary" icon="el-icon-search" @click="insertd()">新增</el-button>
				</el-form-item>
			</el-form>
		</el-card>
			<el-card style="margin-top: 10px;width:25%;float:left">
				<div slot="header" class="clearfix">
      <span>产品型号</span>
      <el-button style="float: right; padding: 3px 0" type="text" @click="open">添加新型号</el-button>
    </div>
		<div>
			  <el-tree :props="props" show-checkbox :load="loadNode" lazy ref="lazytree" default-expand-all :check-on-click-node="true">
					   <span class="custom-tree-node" slot-scope="{ node, data }">
						<span>{{ node.label }}</span>
						<span style="float:right;margin-left:30px">{{"产值："+ data.LMoney }}</span>
					</span>
				    </el-tree>
		</div>
		</el-card>
		<el-card style="margin-top: 10px;width:72%;float:left;margin-left:5px">
			<el-table ref="multipleTable" :data="listinData.slice((currentPage - 1) * pagesize, currentPage * pagesize)"
				border id="el-table" v-loading="loading" class="demo-Form" :highlight-current-row="false" 
				 element-loading-text="拼命加载中" style="width: 100%;" 
				@selection-change="handleSelectionChange" :span-method="objectSpanMethod"
				:header-cell-style="{'text-align':'center'}" @row-dblclick="handleRowClick">
				  <el-table-column align="center"  prop="images" label="产品图片" class="demo-ruleForm" >
				<template slot-scope="scope">
				   <el-upload
				     class="upload-demo"
				 	   ref="upload" 
				    :action="'/api/xxxx/xxxxxxxxxxxxx/'"
				    :on-change="uploadEditFile" 
				     :on-preview="handlePreview"
				     :on-remove="handleRemove"
				     :file-list="scope.row.images"
						 :limit="1"
				     list-type="picture"
				     :auto-upload="false">
				     <el-button size="small" type="primary" @click='getno(scope.row)' >点击上传(只能上传jpg/png文件，且不超过500kb)</el-button>
				   </el-upload>
				 </template>
			  </el-table-column>
				<el-table-column align="center"  prop="LName" label="产品名称" >
				</el-table-column>
				<el-table-column align="center"  prop="LModel" label="产品型号" >
				</el-table-column>
				<el-table-column align="center"  prop="LCount" label="兑换所需积分" >
				</el-table-column>
				<!-- 	<el-table-column align="center"  prop="LMone" label="兑换所需货值">
				</el-table-column>
			<el-table-column align="center"  prop="LDate" label="录入日期" >
				</el-table-column> -->
				<el-table-column align="center"  prop="LReamrk" label="备注" >
				</el-table-column>
				<el-table-column align="center"  prop="contuil" label="操作">
					<template slot-scope="scope">
					 <el-button type="text" size="small" @click="spearchange(scope.row)">修改</el-button>
					 <el-button type="text"  size="small" @click="spear(scope.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div class="block">
				<el-pagination align="center" @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page="currentPage" :page-sizes="[5,10,15,20]" :page-size="pagesize"
					layout="total, sizes, prev, pager, next, jumper" :total="listinData.length">
				</el-pagination>
			</div>
		</el-card>

		 <el-dialog :title="title" :visible.sync="editFormVisible" width="30%">
      <el-form label-width="80px" ref="editForm" :model="editForm" >
        <el-form-item label="产品名称" prop="CPName">
          <el-input size="small" v-model="editForm.CPName" auto-complete="off" placeholder="请输入产品名称"></el-input>
        </el-form-item>
        <!-- <el-form-item label="产品型号" prop="modeId">
          <el-select size="small" v-model="editForm.modeId" placeholder="请选择" class="userRole">
           	<el-option v-for="item in ModelTable" :key="item.LItemID" :value-key="item.LItemID" :label="item.LName"
							:value="item.LItemID">
							<span style="float: left; color: #8492a6; font-size: 17px">{{
				                  item.LName
				                }}</span>
						</el-option>
						
          </el-select>
        </el-form-item> -->
        <el-form-item label="兑换所需积分" prop="LMone">
          <el-input type="number" size="small" v-model="editForm.LMone" placeholder="请输入兑换所需积分"></el-input>
        </el-form-item>
		<el-form-item label="备注" prop="LReamrk">
          <el-input size="small" v-model="editForm.LReamrk" placeholder="请输入备注"></el-input>
        </el-form-item>
       
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="flase()">取消</el-button>
        <el-button size="small" type="primary"  @click="submitForm('editForm')">保存</el-button>
      </div>
			</el-dialog>
	</div>
</template>
<script>
	import {
		deptList,
		deptSave,
		deptDelete,
		login,
		GetLB,
		accountset,
		LinkQueryApp,
		LinkUpNextApp,
		OperateBill
	} from '../../api/userMG'
	import Pagination from '../../components/Pagination'
	import axios from 'axios';
	import FileSaver from 'file-saver'
	import XLSX from 'xlsx'
import Qrcode from '@xkeshi/vue-qrcode'
	export default {
		data() {
			return {
				props: {
					label: 'name',
					children: 'zones'
				},
				centerDialogVisible: false,
				v_str_AccountID: '165',
				nshow: true, //switch开启
				fshow: false, //switch关闭
				loading: false, //是显示加载
				load: false,
				editFormVisible: false, //控制编辑页面显示与隐藏
				//upselect: false,
				title: '添加',
				tableDataLIe: [],
				listinData: [],
				readonly: true,
				gridData: [],
				editForm: {
					CPName:"",
					modeId:"",
					LMone:"",
					LReamrk:"",
				},
				dialogFormVisible: false,
				dailogTitleType1: '目标单据',
				sumlist: [],
				currentPage: 1, //默认显示第一页
				pagesize: 10, //默认每页显示10条
				totalNum: 0, //总页数
				cless: '',
				tableLabel:[
					{
						item:'产品名称',
						label:'产品名称'
					},
					{
						item:'产品型号',
						label:'产品型号'
					}
				],
				dept: [],
				ModelTable:[],
				needMergeArr: [],
				rowMergeArrs: [],
				upnext: '',
				formInline: {
					page: 1,
					limit: 10,
					varLable: '',
					varName: '',
					BIllName:'产品名称',
					deptName:'',
					token: localStorage.getItem('logintoken'),
					data: [
						[{}]
					]
				},
				SysId: '',
				LId: '',
				billNO: '',
				listData: [], //用户数据
				multipleSelection: [],
				Name: '',
				v_str_AccountID:'165',
				maxID:0
			}
		},
		// 注册组件
		components: {
			Pagination
		},
		/**
		 * 数据发生改变
		 */
		/**
		 * 创建完毕
		 */
		watch: {
			'$route'(to, from) {
				this.$router.go(0);
				//  console.log(to)
			}
		},
		created() {
			this.getPath()
		},
		
		/**
		 * 里面的方法只有被调用才会执行
		 */
		 components: {
      "qrcode": Qrcode // 引入 打开终端 如果报错 就是没有安装qrcode  >npm install qrcode 即可
    },
		methods: {
			getno(row){
					this.maxID=row.LItemID
					},
			submitForm(){
				let phems="";
				if(this.SysId==1){
					 phems={
							'v_str_AccountID': this.v_str_AccountID,
							'jsSQL':"{\"SQL\":[{\"insert\":\" insert into A_CP (LName,LCount,LModel,LReamrk)values ('"+this.editForm.CPName+"','"+this.editForm.LMone +"','','"+this.editForm.LReamrk+"')\"}]}"
			}
			}else{
				 phems={
			'v_str_AccountID': this.v_str_AccountID,
			'jsSQL':"{\"SQL\":[{\"insert\":\" update A_CP  set LName='"+this.editForm.CPName+"',LCount='"+this.editForm.LMone +"',LModel='',LReamrk='"+this.editForm.LReamrk+"' where LItemID='"+this.LId+"' \"}]}"
			}
			}
			login(phems).then(res => {
			 if(res.Result=="Y"){
				 this.$message({
					type: 'sucess',
					message: "成功"
				});

			 	}else{
			this.$message({
					type: 'error',
					message: "失败"
				});
		}
			  
			})
			this.getPath();
			},
			flase(){
				this.editFormVisible=false;
			},
			tabsop() {
				this.moui = 1
			},
			tabsops() {
				this.moui = 0
			},
			handleSizeChange(val) {
				//console.log(`每页 ${val} 条`);
				this.pagesize = val;
			},
			loadNode(node, resolve,tu) {
					let ID=this.projectID,arr='';
					let phems = {
					'v_str_AccountID': this.v_str_AccountID,
					'jsSQL': "{\"SQL\":[{\"select\":\"  select * from  A_Model  \"}]}"
				}
				login(phems).then(data => {
					arr = data.Data.Table
					this.ModelTable=arr
					arr.forEach(item =>{
						item['name']=item['LName']
						item['LParentID']=0
					})
					if (node.level === 0) {
					return resolve(arr);
				  }
			    setTimeout(() => {
						 var data;
					   if(node.data.children){
						   data=node.data.children
					   }else{
						   data=[]
					   } resolve(data);
			      }, 500);
				})
			},
			handleCurrentChange(val) {
				this.currentPage = val;
				let litdata=this.listinData.slice((this.currentPage - 1) * this.pagesize, this.currentPage * this.pagesize)
				this.rowMergeArrs = this.rowMergeHandle(this.needMergeArr, litdata); 
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			trceshi(row) {
			},
			handleRowClick(row, column, event) {
				this.$refs.multipleTable.toggleRowSelection(row);
			},
			insertd(){
				this.SysId=1
				this.editForm.CPName="",
				this.editForm.modeId="",
				this.editForm.LMone="",
				this.editForm.LReamrk="",
        this.editFormVisible=true;
			},
			async uploadEditFile(fileList, fileEditList) {
			const form = new FormData();
			console.log(fileList, fileEditList)
			fileEditList.forEach((item) => {
			form.append("file", item.raw);//二进流
			form.append("FAccId", '-1');
			form.append("LProgramNo", '001');
			form.append("LFileName", item.name);
			form.append("LUser",'admin');
			form.append("LType", 'LProgramNo');
			form.append("LUpDate", '');
			form.append("LItemID", this.maxID);
			form.append("FolderName", 'Update');
			});      
		let res=  await this.$axios.post("https://rifengczyxzx.com/UpLoadFile.ashx", form,{
			headers:{
				'Content-Type': 'multipart/form-data',
			}
		});
	
		if(res.data.split('成功').length>1){
		
			this.$message({
					type: 'sucess',
					message: "上传成功"
				});
		}else{
			this.$message({
					type: 'error',
					message: "上传失败"
				});
		}
		console.log(res)
		},
		 handlePreview(file) {
			          console.log(file);
			        },
		 handleRemove(file,fileList) {
					let that=this;
			
					this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
					  confirmButtonText: '确定',
					  cancelButtonText: '取消',
					  type: 'warning'
					}).then(() => {
							let phemss = {
							'v_str_AccountID': '-1',
							'jsSQL': "{\"SQL\":[{\"delete\":\"delete  from t_Archinve where LID='"+file.ID+"'\"}]}"
						}
						 login(phemss).then(res => {
								if(res.Result=='Y'){
									this.$message({
								type: 'succes',
								message: '删除成功'
							});
             	}else{
								 that.$message({
								type: 'error',
								message: '删除失败，请检查'
							});
							 }
						})
				  this.getPath()
					}).catch(() => {
					  this.$message({
						type: 'info',
						message: '已取消删除'
					  });          
					});
				
				  },
	
			mergeAction(val, rowIndex) {
			    let _row = this.rowMergeArrs[val].rowArr[rowIndex];
			    let _col = _row > 0 ? 1 : 0;
			    return [_row, _col];
			},
			async search(){
				this.currentPage=1
					this.getPath()
				},
			spearchange(row){
				this.SysId=2
				this.LId=row.LItemID
				this.editForm.CPName=row.LName,
				this.editForm.modeId=row.LModel,
				this.editForm.LMone=row.LCount,
				this.editForm.LReamrk=row.LReamrk,
        this.editFormVisible=true
			},
			spear(row){
					this.$confirm('此操作将永久删除该产品, 是否继续?', '提示', {
					  confirmButtonText: '确定',
					  cancelButtonText: '取消',
					  type: 'warning'
					}).then(() => {
							let phemss = {
							'v_str_AccountID': this.v_str_AccountID,
							'jsSQL': "{\"SQL\":[{\"delete\":\"delete  from A_CP where LItemID='"+row.LItemID+"'\"}]}"
						}
						 login(phemss).then(res => {
								if(res.Result=='Y'){
									this.$message({
								type: 'succes',
								message: '删除成功'
							});
             	}else{
								 that.$message({
								type: 'error',
								message: '删除失败，请检查'
							});
							 }
						})
				  this.getPath()
					}).catch(() => {
					  this.$message({
						type: 'info',
						message: '已取消删除'
					  });          
					});
				
			},
			rowMergeHandle(arr, data) {
			      if (!Array.isArray(arr) && !arr.length) return false;
			      if (!Array.isArray(data) && !data.length) return false;
			      let needMerge = {};
			      arr.forEach((i, idx) => {
			        needMerge[i] = {
			          rowArr: [],
			          rowMergeNum: 0,
			        };
			        if (idx == 0) {
			          data.forEach((item, index) => {
			            // 表格首个数据单独处理
			            if (index === 0) {
			              needMerge[i].rowArr.push(1);
			              needMerge[i].rowMergeNum = 0;
			            } else {
			              if (item[i] === data[index - 1][i]) {
			                needMerge[i].rowArr[needMerge[i].rowMergeNum] += 1;
			                needMerge[i].rowArr.push(0);
			              } else {
			                needMerge[i].rowArr.push(1);
			                needMerge[i].rowMergeNum = index;
			              }
			            }
			          });
			        } else {
			          let firstRowArr = needMerge[arr[0]].rowArr;
			          let firstRowArrDeal = [];
			          firstRowArr.forEach((item, index) => {
			            if (item > 0) {
			              firstRowArrDeal.push(index);
			            }
			          });
			          data.forEach((item, index) => {
			            let sign = false;
			            if (firstRowArrDeal.indexOf(index) > 0) {
			              needMerge[i].rowMergeNum = index;
			              sign = true;
			            }
			            // 表格首个数据单独处理
			            if (index === 0) {
			              needMerge[i].rowArr.push(1);
			              needMerge[i].rowMergeNum = 0;
			            } else {
			              if (item[i] === data[index - 1][i]) {
			                if (sign) {
			                  needMerge[i].rowArr.push(1);
			                } else {
			                  needMerge[i].rowArr[needMerge[i].rowMergeNum] += 1;
			                  needMerge[i].rowArr.push(0);
			                }
			              } else {
			                needMerge[i].rowArr.push(1);
			                needMerge[i].rowMergeNum = index;
			              }
			            }
			          });
			        }
			      });
				 // console.log(needMerge)
			     return needMerge;
			},
			objectSpanMethod({ row, column, rowIndex, columnIndex }) {
			    for(let res in this.needMergeArr){
			        if(this.needMergeArr[res] == column.property){
			            return this.mergeAction(column.property, rowIndex, columnIndex);
			        }
			    }
			},
			seedefor() {
				this.centerDialogVisible = true
			},
			open(){

			},
			async getPath(plant) {
				let TableLine = [],datjin="";
				let selectOnline = [];
				let dat="",why="";
				if(this.formInline.BIllName=='产品名称'){
					dat='LName'
				}else if(this.formInline.BIllName=='产品型号'){
					dat='LModle'
				}
				if(this.formInline.deptName!=''){
					dat=dat+" like '%"+this.formInline.deptName+"%'"
				}else{
					dat='1=1'
				}
				let phemss = {
					'v_str_AccountID': this.v_str_AccountID,
					'jsSQL': "{\"SQL\":[{\"SELECT\":\" SELECT * FROM V_Cp where "+dat +"  order by LItemID \"}]}"
				}
				await login(phemss).then(res => {
					let arr = res.Data.Table
					arr.forEach(item =>{
								item["images"]=new Array();
								if(item.LFileName){
									let	image="https://rifengczyxzx.com/Update/"+item.LFileName
					      	item["images"].push({
												url:image,
												ID:item.LID,
												name:item.LFileName
											})
								}
					})
					console.log(arr)
					this.listinData = arr
				})
				//this.$options.methods.MaxNum()
			},
		}
	}
</script>

<style scoped>
	.user-search {
		margin-top: 20px;
	}

	.userRole {
		width: 100%;
	}

	.active {
		background: #409eff;
		color: #fff;
	}

	.demo-ruleForm>>>.el-input__inner {
		border: 0;
		background-color:
			#FFF;
		color: #606266;
		/*text-align: center;*/
	}

	.demo-Form>>>.el-table__body tr:hover>td.el-table__cell {
		background-color: #FFF !important;
	}

	.demo-Form>>>.el-table__cell {
		padding: 5px;

	}

	.demo-ruleForm>>>.el-icon-arrow-up:before {
		content: '' !important;
	}

	.demo-ruleForm>>>.el-card__body {
		padding-top: 0px;
	}

	.demo-ruleForm>>>.el-table__body-wrapper {
		height: calc(100% - 70px) !important;
	}

	/deep/.el-popper[x-placement^=bottom] .popper__arrow::after {
		border-bottom-color: transparent;
	}

	/deep/.el-popper .popper__arrow,
	.el-popper .popper__arrow::after {
		border-style: none !important;
	}

	/deep/.el-table__footer-wrapper tbody td.el-table__cell {
		font-size: 1px;
	}

	/deep/.el-table .el-table__footer-wrapper .cell {
		font-size: 1px;
	}
</style>



// WEBPACK FOOTER //
// src/views/machine/MachineAisle.vue